import { NavLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { mainColors } from '@avantstay/backoffice-core'

const LinkStyle = css`
  display: flex;
  align-items: center;
  color: ${mainColors.accentMedium};
  font-size: 14px;
  font-weight: normal;
  stroke: ${mainColors.accentMedium};

  svg {
    margin-right: 8px;
  }

  &:hover {
    text-decoration: underline;
  }
`

const Link = styled(NavLink)`
  ${LinkStyle}
`

export const DefaultLink = styled.a`
  ${LinkStyle}
`

export default Link
